var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 11.512V12.7736C0 14.5499 1.45003 16 3.22644 16H11.9158C13.6921 16 15.1422 14.55 15.1422 12.7736V11.512C15.1422 10.9653 14.6991 10.5214 14.1516 10.5214C13.6049 10.5214 13.161 10.9645 13.161 11.512V12.7736C13.161 13.4565 12.5988 14.0196 11.915 14.0196H3.22652C2.54356 14.0196 1.98052 13.4573 1.98052 12.7736V11.512C1.98052 10.9653 1.53741 10.5214 0.989943 10.5214C0.443257 10.5214 0 10.9645 0 11.512Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.74383 11.6414H9.39691C9.62197 11.6414 9.80576 11.4576 9.80576 11.2325L9.80654 4.81413C9.80654 4.58907 9.99032 4.40528 10.2154 4.40528H11.4715C11.6436 4.40528 11.79 4.30482 11.8523 4.14517C11.9146 3.98475 11.8749 3.81186 11.748 3.69584L10.0448 2.12976L7.8473 0.108052C7.69077 -0.0360174 7.45091 -0.0360174 7.29361 0.108052L5.09607 2.12976L3.39293 3.69584C3.26678 3.81187 3.22628 3.98553 3.28858 4.14517C3.35088 4.3056 3.49807 4.40528 3.6694 4.40528H4.92553C5.15058 4.40528 5.33437 4.58907 5.33437 4.81413V11.2325C5.33515 11.4584 5.51877 11.6414 5.74383 11.6414Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.edf36d30ff1a8208bf606d17375ea526.svg";
export { ForwardRef as ReactComponent };